export const COURSE_STATUS = [
  { label: 'همه', value: 0 },
  { label: 'فعال', value: 3 },
  { label: 'غیر فعال', value: 4 },
];
